//

export const toPlainText = raw => {
  return raw.blocks
    .filter(block => block.type === 'unstyled')
    .map(block => block.text)
    .join('\n');
};
